import { render, staticRenderFns } from "./step4.vue?vue&type=template&id=bffd2cac&scoped=true"
import script from "./step4.vue?vue&type=script&lang=ts"
export * from "./step4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffd2cac",
  null
  
)

export default component.exports